export const routes = [
    {
        name: 'resource',
        path: '/resource',
        meta: {
            permission: 'Resource',
            breadcrumb: [
                {
                    text: 'backoffice.nav.standary_capacity',
                    active: true,
                }
            ],
            permisson: 'Resource',
        },
        component: () => import(/* webpackChunkName: "permission" */ '@/views/permission-management/resource/Resource.vue'),
    }, {
        path: '/capacity/',
        name: 'capacity',
        meta: {
            permission: 'Capacity',
            breadcrumb: [
                {
                    text: 'backoffice.nav.custom_capacity',
                    active: true,
                }
            ],
            permisson: 'Capacity',
        },
        component: () => import(/* webpackChunkName: "permission" */ '@/views/permission-management/capacity/Capacity.vue'),
    },
    {
        path: '/service/',
        name: 'service',
        meta: {
            permission: 'Service',
            breadcrumb: [
                {
                    text: 'backoffice.nav.standary_capacity',
                    active: true,
                }
            ],
            permisson: 'Service',
        },
        component: () => import(/* webpackChunkName: "permission" */ '@/views/permission-management/service/Service.vue'),
    }
];
